import { SideContext } from '@/App';
import LayerManage from '@/commons/components/layer/LayerManage';
import { SideStatus } from '@/commons/context/side-store';
import { SIDE_TYPE } from '@/commons/enums/side-type';
import { ReactComponent as BaoCunSvg } from '@/commons/icons/new/baocun.svg';
import { ReactComponent as ModelFileSvg } from '@/commons/icons/new/model-file.svg';
import { graphicStore } from '@/commons/store/graphic-store';
import { useContext, useEffect, useState } from 'react';
import { DragModal } from 'tncet-common';


import { ReactComponent as GonggongkuaiSvg } from '@/commons/icons/menu/manage/gonggongkuai.svg';
import { ReactComponent as MoxingSvg } from '@/commons/icons/menu/manage/moxing.svg';
import { ReactComponent as QuanxianSvg } from '@/commons/icons/menu/manage/quanxian.svg';
import { ReactComponent as RenwuSvg } from '@/commons/icons/menu/manage/renwu.svg';
import { ReactComponent as TongzhiSvg } from '@/commons/icons/menu/manage/tongzhi.svg';
import { ReactComponent as TucengSvg } from '@/commons/icons/menu/manage/tuceng.svg';
import { ReactComponent as WenjianSvg } from '@/commons/icons/menu/manage/wenjian.svg';
import { ReactComponent as WenziSvg } from '@/commons/icons/menu/manage/wenzi .svg';
import { ReactComponent as XianxingSvg } from '@/commons/icons/menu/manage/xianxing.svg';
import { ReactComponent as ZhushiSvg } from '@/commons/icons/menu/manage/zhushi .svg';
import { ReactComponent as GroupSvg } from '@/commons/icons/menu/manage/group.svg';
import classNames from 'classnames';
import { User } from '@/commons/interface/project/user';
import { getUsersCheckLogin } from '@/api/project/user';
import { USER_TYPE } from '@/commons/enums/user';
import { useNavigate } from 'react-router-dom';
import localStore from '@/commons/store/local-store';



export default function ProjectMenu() {
    const navigate = useNavigate();
    const sideContext = useContext<SideStatus>(SideContext);

    const [showLayerManage, setShowLayerManage] = useState<boolean>(false);

    const [isManager, setIsManager] = useState<boolean>(false)

    const onClick = (route: string) => {
        graphicStore.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        sideContext.setSelectedPanelValue(route);
    }

    useEffect(() => {
        getUsersCheckLogin().then(res => {
            let user: User = res.data
            if (user?.type == USER_TYPE.ADMIN) {
                setIsManager(true)
            }
        }).catch(err => {
            localStore.clear();
            navigate("/login");
        })
    }, [])

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className={classNames({
                                "ope-item": true,
                                "name2": true,
                                "disabled": !isManager
                            })} onClick={() => {
                                if (isManager) {
                                    onClick(SIDE_TYPE.permission)
                                }
                            }}>
                                <div className='icon'><QuanxianSvg /></div>
                                <div className='name'>权限</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><RenwuSvg /></div>
                                <div className='name'>任务</div>
                            </div>
                            <div className='ope-item name2' onClick={() => onClick(SIDE_TYPE.model)}>
                                <div className='icon'><MoxingSvg /></div>
                                <div className='name'>模型</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><WenjianSvg /></div>
                                <div className='name'>文件</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><GonggongkuaiSvg /></div>
                                <div className='name'>块</div>
                            </div>
                            <div className='layer-icon' onClick={() => {
                                setShowLayerManage(true);
                                if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
                                graphicStore?.extraContext?.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
                            }}>
                                <div className='ope-item name2 ' onClick={() => { }}>
                                    <div className='icon'>
                                        <TucengSvg /></div>
                                    <div className='name'>图层</div>
                                </div></div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><WenziSvg /></div>
                                <div className='name'>文字</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><XianxingSvg /></div>
                                <div className='name'>线型</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.group) }}>
                                <div className='icon'><GroupSvg /></div>
                                <div className='name'>组</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ZhushiSvg /></div>
                                <div className='name'>注释</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><TongzhiSvg /></div>
                                <div className='name'>通知</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onClick(SIDE_TYPE.backup) }}>
                                <div className='icon'><BaoCunSvg /></div>
                                <div className='name'>备份</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <DragModal
                title="图层管理"
                visible={showLayerManage}
                width={1000}
                mask
                destroyOnClose
                onClose={() => setShowLayerManage(false)}>
                <LayerManage />
            </DragModal>
        </div>
    )
}